// client/src/neetjee_guru/pages/LibraryManagement.jsx
import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import { isBrowser } from "react-device-detect";

import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";

import LibraryDashboard from "../components/libraryManagement/LibraryDashboard";
import BookCatalog from "../components/libraryManagement/BookCatalog";
import IssueBook from "../components/libraryManagement/IssueBook";
import ReturnBook from "../components/libraryManagement/ReturnBook";
import Fines from "../components/libraryManagement/Fines";
import Reports from "../components/libraryManagement/Reports";
import LibrarySettings from "../components/libraryManagement/LibrarySettings";
import { GET_STUDENT_ACTIVE_LOANS } from "../components/libraryManagement/queries";

const VALID_TABS = ["dashboard", "issue_return", "catalog", "reports", "fines", "settings"];

class LibraryManagement extends Component {
  constructor(props) {
    super(props);
    const tabParam = props.match && props.match.params && props.match.params.tab;
    this.state = {
      selectedBorrower: null,
      activeLoans: [],
      loadingLoans: false,
      transactionSubTab: tabParam === "return" ? "return" : "issue",
      toasts: [],
    };
  }

  showToast = (text, type = "success") => {
    const id = Date.now();
    this.setState((prev) => ({
      toasts: [...prev.toasts, { id, text, type }],
    }));
    setTimeout(() => {
      this.setState((prev) => ({
        toasts: prev.toasts.filter((t) => t.id !== id),
      }));
    }, 3500);
  };

  componentDidUpdate(prevProps) {
    const prevTab = prevProps.match && prevProps.match.params && prevProps.match.params.tab;
    const currentTab = this.props.match && this.props.match.params && this.props.match.params.tab;
    if (currentTab !== prevTab) {
      if (currentTab === "issue") {
        this.setState({ transactionSubTab: "issue" });
      } else if (currentTab === "return") {
        this.setState({ transactionSubTab: "return" });
      }
    }
  }

  loadBorrowerLoans = async (borrower) => {
    if (!borrower || !borrower.id || isNaN(borrower.id)) {
      this.setState({ activeLoans: [], loadingLoans: false });
      return;
    }

    const { client } = this.props;
    const instId = parseInt(Cookies.get("institute_id") || Cookies.get("institutionid") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || Cookies.get("branchid") || "0");

    try {
      this.setState({ loadingLoans: true });
      const { data } = await client.query({
        query: GET_STUDENT_ACTIVE_LOANS,
        variables: { borrower_id: borrower.id, borrower_type: borrower.type, institute_id: instId, branch_id: branchId },
        fetchPolicy: "network-only"
      });
      this.setState({ activeLoans: data.getStudentActiveLoans || [], loadingLoans: false });
    } catch (err) {
      console.error("Error loading borrower loans in parent:", err);
      this.setState({ loadingLoans: false });
    }
  };

  setSelectedBorrower = (borrower) => {
    this.setState({ selectedBorrower: borrower }, () => {
      this.loadBorrowerLoans(borrower);
    });
  };

  refreshLoans = () => {
    this.loadBorrowerLoans(this.state.selectedBorrower);
  };

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      Cookies.set("toggle", "wrapper");
    }
    this.forceUpdate();
  };

  setActiveTab = (tab) => {
    this.props.history.push(`/library/${tab}`);
  };

  render() {
    if (Cookies.get("token") === undefined && this.props.history) {
      this.props.history.push("/login");
    }

    const { client, match } = this.props;
    const tabParam = match && match.params && match.params.tab;
    
    // Support backward compatibility for direct routes /library/issue and /library/return
    let activeTab = "dashboard";
    if (VALID_TABS.includes(tabParam)) {
      activeTab = tabParam;
    } else if (tabParam === "issue" || tabParam === "return") {
      activeTab = "issue_return";
    }

    const tabs = [
      { key: "dashboard", label: "Dashboard", icon: "fal fa-tachometer-alt" },
      { key: "issue_return", label: "Issue & Return", icon: "fal fa-exchange-alt" },
      { key: "catalog", label: "Book Catalog", icon: "fal fa-book" },
      { key: "reports", label: "Reports", icon: "fal fa-chart-line" },
      { key: "fines", label: "Fines & Payments", icon: "fal fa-hand-holding-usd" },
      { key: "settings", label: "Settings", icon: "fal fa-cogs" },
    ];

    return (
      <div className={Cookies.get("toggle") || "wrapper"}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser === true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px" }}>
              <Container fluid className="px-0">
                
                <style dangerouslySetInnerHTML={{__html: `
                  .shimmer {
                    background: #e9edf2;
                    background-image: linear-gradient(90deg, #e9edf2 0px, #f4f7fa 60px, #e9edf2 120px);
                    background-size: 200% 100%;
                    border-radius: 6px;
                    animation: shimmerMove 1.3s ease-in-out infinite;
                  }
                  @keyframes shimmerMove {
                    0% { background-position: -150px 0; }
                    100% { background-position: 250px 0; }
                  }
                  .custom-card-shadow {
                    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.05) !important;
                  }
                  
                  /* Flat premium active tabs styling */
                  .nav-tabs .nav-link {
                    border: none !important;
                    border-bottom: 2px solid transparent !important;
                    border-radius: 0 !important;
                  }
                  .nav-tabs .nav-link.active {
                    border-bottom: 2px solid #6366f1 !important;
                    color: #6366f1 !important;
                    background: transparent !important;
                  }

                  /* Scoped high contrast styles for modals */
                  .modal-title {
                    color: #0f172a !important;
                  }
                  .modal-header .close {
                    color: #475569 !important;
                    text-shadow: none !important;
                    opacity: 0.7 !important;
                  }
                  .modal-header .close:hover {
                    color: #0f172a !important;
                    opacity: 1 !important;
                  }
                  .modal-body label {
                    color: #334155 !important;
                    font-weight: 700;
                  }
                `}} />

                <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                  
                  {/* Tab Navigation header */}
                  <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
                    <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                      {tabs.map((tab) => {
                        const isActive = activeTab === tab.key;
                        return (
                          <li className="nav-item" key={tab.key}>
                            <a
                              className={`nav-link ${isActive ? "active" : ""}`}
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setActiveTab(tab.key);
                              }}
                              style={{
                                cursor: "pointer",
                                fontWeight: 700,
                                fontSize: 14,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                padding: "16px 20px",
                                color: isActive ? "#6366f1" : "#4b5563",
                                background: "transparent",
                                border: "none",
                                borderBottom: isActive ? "2px solid #6366f1" : "2px solid transparent",
                                borderRadius: "0px",
                                transition: "all 0.15s ease",
                                marginBottom: "-1.5px"
                              }}
                            >
                              <i className={tab.icon} />
                              {tab.label}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  {/* Tab Content Panel */}
                  <div style={{ padding: "28px" }}>
                    {activeTab === "dashboard" && <LibraryDashboard client={client} showToast={this.showToast} />}
                    {activeTab === "catalog" && <BookCatalog client={client} showToast={this.showToast} />}
                    {activeTab === "issue_return" && (
                      <div>
                        {/* Segmented Control Sub-tabs */}
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "28px" }}>
                          <div style={{ background: "#f1f5f9", padding: "4px", borderRadius: "10px", display: "inline-flex", gap: "4px", border: "1px solid #e2e8f0" }}>
                            <button
                              onClick={() => this.setState({ transactionSubTab: "issue" })}
                              style={{
                                border: "none",
                                borderRadius: "8px",
                                padding: "8px 24px",
                                fontSize: "13px",
                                fontWeight: 700,
                                cursor: "pointer",
                                background: this.state.transactionSubTab === "issue" ? "#fff" : "transparent",
                                color: this.state.transactionSubTab === "issue" ? "#6366f1" : "#64748b",
                                boxShadow: this.state.transactionSubTab === "issue" ? "0 2px 8px rgba(99, 102, 241, 0.08)" : "none",
                                transition: "all 0.2s ease"
                              }}
                            >
                              <i className="fal fa-book-reader mr-2" style={{ marginRight: 8 }} />
                              Issue Book
                            </button>
                            <button
                              onClick={() => this.setState({ transactionSubTab: "return" })}
                              style={{
                                border: "none",
                                borderRadius: "8px",
                                padding: "8px 24px",
                                fontSize: "13px",
                                fontWeight: 700,
                                cursor: "pointer",
                                background: this.state.transactionSubTab === "return" ? "#fff" : "transparent",
                                color: this.state.transactionSubTab === "return" ? "#6366f1" : "#64748b",
                                boxShadow: this.state.transactionSubTab === "return" ? "0 2px 8px rgba(99, 102, 241, 0.08)" : "none",
                                transition: "all 0.2s ease"
                              }}
                            >
                              <i className="fal fa-undo mr-2" style={{ marginRight: 8 }} />
                              Return / Renew Book
                            </button>
                          </div>
                        </div>

                        {/* Content of Sub-tab */}
                        {this.state.transactionSubTab === "issue" ? (
                          <IssueBook
                            client={client}
                            selectedBorrower={this.state.selectedBorrower}
                            setSelectedBorrower={this.setSelectedBorrower}
                            activeLoans={this.state.activeLoans}
                            loadingLoans={this.state.loadingLoans}
                            refreshLoans={this.refreshLoans}
                            showToast={this.showToast}
                          />
                        ) : (
                          <ReturnBook
                            client={client}
                            selectedBorrower={this.state.selectedBorrower}
                            setSelectedBorrower={this.setSelectedBorrower}
                            activeLoans={this.state.activeLoans}
                            loadingLoans={this.state.loadingLoans}
                            refreshLoans={this.refreshLoans}
                            showToast={this.showToast}
                          />
                        )}
                      </div>
                    )}
                    {activeTab === "fines" && <Fines client={client} showToast={this.showToast} />}
                    {activeTab === "reports" && <Reports client={client} showToast={this.showToast} />}
                    {activeTab === "settings" && <LibrarySettings client={client} showToast={this.showToast} />}
                  </div>

                </div>
              </Container>
            </div>
          </div>
          <Footer />
        </div>

        {/* Floating Toast Notification Stack */}
        <div style={{ position: "fixed", top: "24px", right: "24px", zIndex: 99999, display: "flex", flexDirection: "column", gap: "12px", maxWidth: "350px" }}>
          {this.state.toasts.map(toast => (
            <div
              key={toast.id}
              style={{
                background: "#fff",
                borderLeft: `5px solid ${toast.type === "success" ? "#10b981" : "#ef4444"}`,
                borderRadius: "8px",
                padding: "12px 18px",
                boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.08)",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                fontSize: "13px",
                fontWeight: 600,
                color: "#1e293b",
                border: "1px solid #e2e8f0"
              }}
            >
              <i className={toast.type === "success" ? "fal fa-check-circle text-success" : "fal fa-exclamation-circle text-danger"} style={{ fontSize: 16 }} />
              <div>{toast.text}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(withApollo(LibraryManagement));
